import apiBase from "../../api/axios";

export const getSchoolsService = async (page = 1, search = "") => {
  let url = `v1/escuela/?page=${page}`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  const response = await apiBase.get(url);
  return response.data;
};

export const createSchoolService = async (payload) => {
  const response = await apiBase.post("v1/escuela/", payload);
  return response.data;
};

export const getSchoolByIdService = async (id) => {
  const response = await apiBase.get(`v1/escuela/${id}/`);
  return response.data;
};

export const updateSchoolService = async (id, payload) => {
  const response = await apiBase.put(`v1/escuela/${id}/`, payload);
  return response.data;
};

export const toggleSchoolActiveService = async (id) => {
  const response = await apiBase.post(`v1/escuela/${id}/toggle_active/`);
  return response.data;
};
